import {
    EMPTY_USERS,
    FETCH_USERS, FETCH_USERS_SUCCESS, FETCH_USERS_FAILURE,
    SAVE_USER_STATUS_START, SAVE_USER_STATUS_SUCCESS, SAVE_USER_STATUS_FAILURE,
    SET_USERS
} from './constants';
import Request from 'utils/request';
import {PATHS} from "../../../utils/paths";

export const emptyUsers = () => ({
    type: EMPTY_USERS
});

const fetchUsers = () => ({
    type: FETCH_USERS
});

const fetchUsersSuccess = (data) => ({
    type: FETCH_USERS_SUCCESS,
    data
});

const fetchUsersFailure = (error) => ({
    type: FETCH_USERS_FAILURE,
    error
});

const saveUserStatusStart = () => ({
    type: SAVE_USER_STATUS_START
});

const saveUserStatusSuccess = (data) => ({
    type: SAVE_USER_STATUS_SUCCESS,
    data
});

const saveUserStatusFailure = (error) => ({
    type: SAVE_USER_STATUS_FAILURE,
    error
});

export const setUsers = (data) => ({
    type: SET_USERS,
    data
});


/**
 *  ASYNC ACTIONS
 */
export const getUsers = () => (dispatch, getStore) => {
    dispatch(fetchUsers());

    let request = new Request(getStore().auth.token);

    return request.get(PATHS.admin.getUsers())
        .then((response) => {
            dispatch(fetchUsersSuccess(response.data.data));
            return response;
        })
        .catch((error) => {
            console.log('getUsers error', error, error.response);
            error.friendlyMessage = 'There was an error getting users. Please try again.';
            dispatch(fetchUsersFailure(error));
            throw error;
        });
};

export const saveUserStatus = (user, command) => (dispatch, getStore) => {
    dispatch(saveUserStatusStart());

    let request = new Request(getStore().auth.token);

    return request.put(PATHS.admin.saveUserStatus(user.id, command), {command})
        .then((response) => {
            if(user.isFreelancer) {
                dispatch(saveUserStatusSuccess(response.data.data));
                return response;
            } else {
                return request.put(PATHS.admin.saveCompanyStatus(user.company.id), {command})
                    .then((response) => {
                        dispatch(saveUserStatusSuccess(response.data.data));
                        return response;
                    })
                    .catch((error) => {
                        console.log('saveUserStatus => saveCompanyStatus error', error, error.response);
                        error.friendlyMessage = 'There was an error changing status. Please try again.';
                        dispatch(saveUserStatusFailure(error));
                        throw error;
                    });
            }
        })
        .catch((error) => {
            console.log('saveUserStatus error', error, error.response);
            error.friendlyMessage = 'There was an error changing status. Please try again.';
            dispatch(saveUserStatusFailure(error));
            throw error;
        });
}



// WEBPACK FOOTER //
// ./src/containers/Users/store/actions.js